export default "__VITE_ASSET__BKm2QnbB__"